var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classnames from 'classnames';
import React from 'react';
import TouchFeedback from './FeedBack';
import { addClass } from '../_utils/class';
import { IS_IOS } from '../_utils/exenv';
import Icon from '../icon';
export class KeyboardItem extends React.Component {
    render() {
        const _a = this.props, { prefixCls, onClick, className, disabled, children, tdRef, label, iconOnly } = _a, restProps = __rest(_a, ["prefixCls", "onClick", "className", "disabled", "children", "tdRef", "label", "iconOnly"]);
        let value = children;
        if (className === 'keyboard-delete') {
            value = 'delete';
        }
        else if (className === 'keyboard-hide') {
            value = 'hide';
        }
        else if (className === 'keyboard-confirm') {
            value = 'confirm';
        }
        else if (className === 'keyboard-space') {
            value = ' ';
        }
        const wrapCls = classnames(`${prefixCls}-item`, className);
        return (<TouchFeedback activeClassName={`${prefixCls}-item-active`}>
        <div ref={tdRef} 
        // tslint:disable-next-line:jsx-no-multiline-js
        onClick={e => {
            onClick(e, value);
        }} className={wrapCls} {...restProps}>
          <div>
            {children}
            {iconOnly && <i className="sr-only">{label}</i>}
          </div>
        </div>
      </TouchFeedback>);
    }
}
KeyboardItem.defaultProps = {
    prefixCls: 'cfm_num_keyboard',
    onClick: () => { },
    disabled: false,
};
class CustomKeyboard extends React.Component {
    constructor() {
        super(...arguments);
        this.onKeyboardClick = (e, value = '') => {
            e.nativeEvent.stopImmediatePropagation();
            if (value === 'confirm' && this.confirmDisabled && this.confirmKeyboardItem) {
                addClass(this.confirmKeyboardItem, `${this.props.prefixCls}-item-disabled`);
                return null;
            }
            else {
                if (this.linkedInput) {
                    this.linkedInput.onKeyboardClick(value);
                }
            }
        };
        this.renderKeyboardItem = (item, index) => {
            return (<KeyboardItem onClick={this.onKeyboardClick} key={`item-${item}-${index}`}>
        {item}
      </KeyboardItem>);
        };
    }
    render() {
        const { prefixCls, confirmLabel, backspaceLabel, wrapProps, header, keyList, } = this.props;
        const wrapperCls = classnames(`${prefixCls}-wrapper`, `${prefixCls}-wrapper-hide`);
        return (<div className={wrapperCls} ref={el => (this.antmKeyboard = el)} {...wrapProps}>
        {header && React.cloneElement(header, { onClick: this.onKeyboardClick })}
        <div className='cfm_num_keyboard_content'>
          <div className='cfm_num_keyboard_left'>
            {keyList.slice(0, 11).map((item, index) => 
        // tslint:disable-next-line:jsx-no-multiline-js
        this.renderKeyboardItem(item, index))}
            <KeyboardItem className="keyboard-hide" onClick={this.onKeyboardClick}><Icon type='down'/></KeyboardItem>
          </div>
          <div className='cfm_num_keyboard_right'>
            
            <KeyboardItem className="keyboard-delete" onClick={this.onKeyboardClick} {...this.getAriaAttr(backspaceLabel)}/>
            <KeyboardItem className="keyboard-confirm" onClick={this.onKeyboardClick} tdRef={el => (this.confirmKeyboardItem = el)}>
              {confirmLabel}
            </KeyboardItem>
          </div>
        </div>
      </div>);
    }
    getAriaAttr(label) {
        if (IS_IOS) {
            return { label, iconOnly: true };
        }
        else {
            return { role: 'button', 'aria-label': label };
        }
    }
}
CustomKeyboard.defaultProps = {
    prefixCls: 'cfm_num_keyboard',
    confirmLabel: 'Confirm',
    keyList: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '0'],
};
export default CustomKeyboard;



// WEBPACK FOOTER //
// ./components/input-key-board/CustomKeyboard.tsx